import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cafeteria',
  templateUrl: './cafeteria.component.html',
  styleUrls: ['./cafeteria.component.scss']
})
export class CafeteriaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
